import React from 'react';

import Accordion from 'components/Accordion';
import DatePicker from 'components/DatePicker';
import useDates from 'hooks/Meteorology/Weather/Comparator/useDates';
import TitleSemiBold from 'components/Typography/TitleSemiBold';

export default function DateAccordion({ modelIndex }: { modelIndex: number }) {
  const accordionId = `date-accordion-${modelIndex}`;
  const {
    date,
    setDate,
    maxDate,
    filterDate,
  } = useDates({ modelIndex, accordionId });

  return (
    <Accordion.Item eventKey="date" id={accordionId}>
      <Accordion.Header>
        <TitleSemiBold>Data de rodada</TitleSemiBold>
      </Accordion.Header>
      <Accordion.Body>
        <DatePicker
          selected={date}
          onChange={setDate}
          maxDate={maxDate}
          filterDate={filterDate}
          inline
        />
      </Accordion.Body>
    </Accordion.Item>
  );
}
